import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ReportsService } from "../reports.service";
import { FormBuilder, Validators, FormControl } from "@angular/forms";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "app-summary-fixture-add",
    templateUrl: "./summary-fixture-add.component.html",
    styleUrls: ["./summary-fixture-add.component.scss"],
})
export class SummaryFixtureAddComponent implements OnInit {
    public fixture: any = null;
    public fixtureData: any = null;
    public isRunning = false;
    public isAthletics = false;
    private fixtureResult = [];
    public isMiniMarathos = false;

    constructor(
        private activetedRoute: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private reportService: ReportsService,
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private router: Router
    ) {
        this.spinner.show();

        this.fixtureData = this.formBuilder.group({});

        this.activetedRoute.params.subscribe((params) => {
            if (params === null || params === undefined) {
                return false;
            }

            this.getFixture(params.id);
        });
    }

    ngOnInit() {}

    getFixture(id: number) {
        this.reportService.getFixtureById(id).subscribe((res) => {
            this.fixture = res.result;

            if (res.result.sport_id === 1) {
                this.isAthletics = true;
            }

            if (
                res.result.category_id <= 64 ||
                (res.result.category_id >= 91 &&
                    res.result.category_id <= 89) ||
                (res.result.category_id >= 247 &&
                    res.result.category_id <= 258) ||
                res.result.sport_id === 13
            ) {
                this.isAthletics = false;
                this.isRunning = true;
            }

            if (res.result.category_id === 275) {
                const athletes = res.result.users.flatMap(
                    (item) => item.atheletes
                );
                this.isMiniMarathos = true;
                console.log(athletes);
            }

            this.prepareFormData(res.result.users);
        });
    }

    prepareFormData(data: any) {
        for (let i = 0; i < data.length; i++) {
            this.fixtureResult[data[i].user_id] = {
                user_id: data[i].user_id,
                score: 0,
                position: "",
                remark: "",
            };

            if (this.isAthletics) {
                this.fixtureData.addControl(
                    `${data[i].user_id}-m`,
                    new FormControl("", Validators.required)
                );

                this.fixtureData.addControl(
                    `${data[i].user_id}-cm`,
                    new FormControl("", Validators.required)
                );

                this.fixtureData.addControl(
                    `${data[i].user_id}-remark`,
                    new FormControl("", [])
                );
            } else if (this.isRunning) {
                this.fixtureData.addControl(
                    `${data[i].user_id}-h`,
                    new FormControl("")
                );
                this.fixtureData.addControl(
                    `${data[i].user_id}-m`,
                    new FormControl("")
                );
                this.fixtureData.addControl(
                    `${data[i].user_id}-s`,
                    new FormControl("")
                );
                this.fixtureData.addControl(
                    `${data[i].user_id}-ss`,
                    new FormControl("")
                );
                this.fixtureData.addControl(
                    `${data[i].user_id}-remark`,
                    new FormControl("", [])
                );
            } else {
                this.fixtureData.addControl(
                    `${data[i].user_id}`,
                    new FormControl("", Validators.required)
                );

                this.fixtureData.addControl(
                    `${data[i].user_id}-remark`,
                    new FormControl("")
                );

                this.fixtureData.addControl(
                    `${data[i].user_id}-position`,
                    new FormControl("")
                );
            }

            if (i === data.length - 1) {
                setTimeout(() => {
                    this.spinner.hide();
                }, 500);
            }
        }
    }

    fixtureDataSubmit(value: any) {
        const fixtureData = { data: [] };
        let i = 1;

        for (const index in value) {
            if (value.hasOwnProperty(index)) {
                if (this.isRunning) {
                    const userId = index.split("-");
                    let milliValue = 0;

                    if (userId[1] === "h") {
                        milliValue = parseInt(value[index], 10) * 3600000;
                    } else if (userId[1] === "m") {
                        milliValue = parseInt(value[index], 10) * 60000;
                    } else if (userId[1] === "s") {
                        milliValue = parseInt(value[index], 10) * 1000;
                    } else if (userId[1] === "ss") {
                        milliValue = parseInt(value[index], 10);
                    } else if (userId[1] === "remark") {
                        this.fixtureResult[+userId[0]].remark = value[index];
                    }

                    this.fixtureResult[+userId[0]].score += milliValue;
                    fixtureData.data = this.fixtureResult;
                } else if (this.isAthletics) {
                    const userAtId = index.split("-");
                    let cmValue = 0;

                    if (userAtId[1] === "m") {
                        cmValue = parseInt(value[index], 10) / 0.01;
                    } else if (userAtId[1] === "cm") {
                        cmValue = parseInt(value[index], 10);
                    } else if (userAtId[1] === "remark") {
                        this.fixtureResult[+userAtId[0]].remark = value[index];
                    }

                    this.fixtureResult[+userAtId[0]].score += cmValue;
                    fixtureData.data = this.fixtureResult;
                } else {
                    const userTwoId = index.split("-");

                    if (userTwoId[1] === "remark") {
                        this.fixtureResult[+userTwoId[0]].remark = value[index];
                    } else if (userTwoId[1] === "position") {
                        this.fixtureResult[+userTwoId[0]].position =
                            value[index];
                    } else {
                        this.fixtureResult[index].score = value[index];
                    }

                    fixtureData.data = this.fixtureResult;
                }

                if (i === Object.keys(value).length) {
                    const fixtureValue = { data: [] };
                    fixtureValue.data = fixtureData.data.filter(() => true);
                    this.reportService
                        .addResult(fixtureValue, this.fixture.id)
                        .subscribe((res) => {
                            this.toastr.success(
                                `เพิ่มผลการแข่งขันสำเร็จ`,
                                "Success"
                            );
                            this.router.navigate([
                                `/report/fixture-list/${this.fixture.sport_id}/${this.fixture.category_id}/${this.fixture.category.sport_name}`,
                            ]);
                        });
                }

                i++;
            }
        }
    }
}
